import { LOGIN } from '_constants';

export const login = (state = {}, action) => {
  let newState = { ...state };
  switch (action.type) {
    case LOGIN.START_LOGIN:
      newState.isLoggingin = true;
      break;
    case LOGIN.END_LOGIN:
      newState.isLoggingin = false;
      break;
    case LOGIN.LOGIN_ERROR:
      newState.logginError = action.payload;
      break;
    case LOGIN.LOGOUT:
      newState = {
        member: null,
        username: null,
        password: null,
        loggedin: false,
        isLoggingin: false,
        isTermsAccepted: false,
        logginError: null
      };
      // newState = INITIAL_APP_STATE.login;
      newState.deviceId = state.deviceId;
      newState.deviceType = state.deviceType;
      newState.appVersion = state.appVersion;
      // maintaining device id from state in local storage after clearing the storage to handle log out scenario.
      localStorage.setItem('clientDeviceInfo', JSON.stringify({ deviceId: state.deviceId, deviceType: state.deviceType, appVersion: state.appVersion }));
      break;
    case LOGIN.ACCEPT_LOGIN_TERMS:
      newState.isTermsAccepted = true;
      break;
    case LOGIN.FETCH_AVAILABLE_METHODS:
      newState.deliveryMethod = action.payload.data || [];
      if (action.payload.data) { newState.formPosition = LOGIN.FORM_POSITION.ENTER_METHOD; }
      break;
    case LOGIN.SEND_CODE_VIA_METHOD:
      newState.newCredentials = action.payload;
      if (action.payload) { newState.formPosition = LOGIN.FORM_POSITION.ENTER_CODE; }
      break;
    case LOGIN.SET_SEND_METHOD:
      newState.sendMethod = action.value;
      break;
    case LOGIN.CODE_VALIDATION:
      if (action.payload) { newState.formPosition = LOGIN.FORM_POSITION.ENTER_PASSWORD; }
      break;
    case LOGIN.SET_VALIDATION_CODE:
      newState.validationCode = action.value || '';
      break;
    case LOGIN.SET_FORM_POSITION:
      newState.resetError = false;
      newState.formPosition = action.value;
      break;
    case LOGIN.START_RESET_ACTION:
      newState.resetError = false;
      break;
    case LOGIN.PASSWORD_RESET_ERROR:
      newState.resetError = true;
      newState.errorMessage = action.payload.message;
      newState.passwordErrors = action.payload.errors;
      break;
    case LOGIN.UPDATE_DEVICE_INFO:
      newState.deviceId = action.deviceId;
      newState.deviceType = action.deviceType;
      newState.appVersion = action.appVersion;
      break;
    case LOGIN.SET_SEND_TIME:
      newState.codeExpiration = action.value;
    default:
      break;
  }
  return newState;
};
